var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.node.location.type === "equipment"
      ? _c("p", [
          _c("strong", [_vm._v("Equipment Type: ")]),
          _vm._v(
            " " +
              _vm._s(
                _vm.adminDataFieldService.getValueFromOptions(
                  "equipmentFieldEquipmentAssociatedApparatus",
                  _vm.node.location.equipmentDetail
                    ?.fieldEquipmentAssociatedApparatus
                )
              ) +
              " "
          ),
        ])
      : _vm._e(),
    _vm.node.location.type === "junction-box"
      ? _c("p", [
          _c("strong", [_vm._v("Equipment Type: ")]),
          _vm._v(
            " " +
              _vm._s(
                _vm.adminDataFieldService.getValueFromOptions(
                  "junctionBoxFieldAssociatedApparatus",
                  _vm.node.location.junctionBoxDetail?.fieldAssociatedApparatus
                )
              ) +
              " "
          ),
        ])
      : _vm._e(),
    _vm.node.location.type === "equipment"
      ? _c("p", [
          _c("strong", [_vm._v("Model No.: ")]),
          _vm._v(
            " " + _vm._s(_vm.node.location.equipmentDetail?.modelNo) + " "
          ),
        ])
      : _vm._e(),
    _vm.node.location.type === "junction-box"
      ? _c("p", [
          _c("strong", [_vm._v("Model No.: ")]),
          _vm._v(
            " " + _vm._s(_vm.node.location.junctionBoxDetail?.modelNo) + " "
          ),
        ])
      : _vm._e(),
    _vm.node.location.type === "equipment"
      ? _c("p", [
          _c("strong", [_vm._v("Manufacturer:")]),
          _vm._v(
            " " + _vm._s(_vm.node.location.equipmentDetail?.manufacturer) + " "
          ),
        ])
      : _vm._e(),
    _vm.node.location.type === "junction-box"
      ? _c("p", [
          _c("strong", [_vm._v("Manufacturer:")]),
          _vm._v(
            " " +
              _vm._s(_vm.node.location.junctionBoxDetail?.manufacturer) +
              " "
          ),
        ])
      : _vm._e(),
    _vm.node.location.type === "equipment"
      ? _c("p", [_c("strong", [_vm._v("Ex Code:")])])
      : _vm._e(),
    _vm.node.location.type === "junction-box"
      ? _c("p", [
          _c("strong", [_vm._v("Ex Code:")]),
          _vm._v(
            " " +
              _vm._s(
                _vm.adminDataFieldService.getValueFromOptions(
                  "junctionBoxProtectionTechniqueGas",
                  _vm.node.location.junctionBoxDetail?.protectionTechniqueGas
                )
              ) +
              " "
          ),
        ])
      : _vm._e(),
    _vm.node.location.type === "equipment"
      ? _c("p", [
          _c("strong", [_vm._v("Ambient Temperature:")]),
          _vm._v(
            " " +
              _vm._s(
                _vm.node.location.equipmentDetail?.lowAmbientTemperature +
                  " to " +
                  _vm.node.location.equipmentDetail?.highAmbientTemperature
              ) +
              " "
          ),
        ])
      : _vm._e(),
    _vm.node.location.type === "junction-box"
      ? _c("p", [
          _c("strong", [_vm._v("Ambient Temperature:")]),
          _vm._v(
            " " +
              _vm._s(
                _vm.node.location.junctionBoxDetail?.lowAmbientTemperature +
                  " to " +
                  _vm.node.location.junctionBoxDetail?.highAmbientTemperature
              ) +
              " "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }